export enum StorageKeys {
  userDetail = 'user-detail',
  AccessToken = 'access-token',
  userID ="user-ID",
  selectedCompany ='selected-company',
  selectedCompanyName='company-name'
}
